/* eslint-disable import/prefer-default-export */
// @flow
import { takeEvery, call, select, put, spawn } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import get from 'lodash/get';

import {
  PRODUCTS,
  receiveToggledFavorite,
} from 'services/actions/productsActions';
import type { RequestToggleFavoritesAction } from 'services/actions/productsActions';
import { updateFavorite as _updateFavorite } from 'services/api/products';
import { segmentEnum, track, btnLocationEnum } from 'utils/segment';
import { selectTrackingData } from 'selectors/trackingSelector';

const { REQUEST_TOGGLE_FAVORITE } = PRODUCTS;

// WATCHER SAGAS
export function* watchUpdateFavorites(): Saga<void> {
  yield takeEvery(REQUEST_TOGGLE_FAVORITE, updateFavorite);
}

// WORKER SAGAS
function* updateFavorite(action: RequestToggleFavoritesAction): Saga<void> {
  const { productId, isLike } = action;
  const campaignId = yield select((state) => state.campaignState.campaignId);
  const toggledFavoriteResponse = yield call(
    _updateFavorite,
    campaignId,
    productId,
    isLike
  );

  yield put(receiveToggledFavorite(toggledFavoriteResponse));

  yield spawn(handleFavoriteTracking, action);
}

function* handleFavoriteTracking(
  action: RequestToggleFavoritesAction
): Saga<void> {
  const {
    productId,
    variantId,
    buttonLocation,
    isLike,
    selectedCategoryId,
    positionLocation,
    referrerProductId,
    positionOrder,
  } = action;

  const isRecommendedProduct =
    buttonLocation === btnLocationEnum.recommendedCard ||
    buttonLocation === btnLocationEnum.recommendedAccordion;

  const trackingDataFromState = yield select((state) =>
    selectTrackingData(state, { productId, variantId, selectedCategoryId })
  );

  const productsDataFromState = yield select((state) => state.productsState);
  const { ratings } = productsDataFromState;
  const productRating = get(ratings, productId, null);

  const trackingData = {
    ...trackingDataFromState,
    experience: buttonLocation,
    ...(positionLocation && { position_location: positionLocation }),
    ...(isRecommendedProduct && {
      component_type: 'p2p recommendation',
      component_label: 'Similar Products',
      referrer_parent_product_id: referrerProductId,
      event_position_order: positionOrder,
    }),
    ...(productRating && {
      star_rating: productRating.averageRating,
      total_reviews: productRating.totalReviewCount,
    }),
  };

  const eventName = isLike
    ? segmentEnum.productFavorited
    : segmentEnum.productUnfavorited;

  track(eventName, trackingData);
}
